import React, {useMemo} from 'react';
import type {TdProps} from '@components/Table/core/Td';
import {ClaimStatus as ClaimStatusType} from '@deezer/next/services/api/Starmania/requests/claim/types';
import {useTranslation} from 'next-i18next';
import TextCell from '@components/Table/cells/TextCell';

type StatusCellProps = {
	status: ClaimStatusType;
} & TdProps;

const ColorStatusMap = {
	[ClaimStatusType.PENDING]: 'text.neutral.secondary.default',
	[ClaimStatusType.PROCESSING]: 'text.neutral.secondary.default',
	[ClaimStatusType.IN_PROGRESS]: 'text.neutral.secondary.default',
	[ClaimStatusType.DENIED]: 'text.feedback.error.default',
	[ClaimStatusType.APPROVED]: 'text.feedback.success.default',
	[ClaimStatusType.DELETED]: 'text.feedback.error.default',
};

const StatusCell = ({status, ...rest}: StatusCellProps) => {
	const {t} = useTranslation('d4c');
	const statusLabel = useMemo(() => {
		switch (status) {
			case ClaimStatusType.PENDING:
				return t('requestmonitoring_text_waitingforapproval_d4c-web');
			case ClaimStatusType.PROCESSING:
			case ClaimStatusType.IN_PROGRESS:
				return t('requestmonitoring_text_inprogress_d4c-web');
			case ClaimStatusType.DENIED:
				return t('requestmonitoring_text_declined_d4c-web');
			case ClaimStatusType.APPROVED:
				return t('requestmonitoring_text_approved_d4c-web');
			case ClaimStatusType.DELETED:
				return t('requestmonitoring_text_deleted_d4c-web');
		}
	}, [status, t]);

	return (
		<TextCell value={statusLabel} color={ColorStatusMap[status]} {...rest} />
	);
};

export default StatusCell;
